const activities = {
    cantina_tilli: {
        name: 'Azienda Tilli',
        subtitle: 'Degustazione Vini e Prodotti Tipici',
        description: 'Visita l\'Azienda Tilli per una degustazione di vini locali e prodotti tipici dell\'Abruzzo. Un\'esperienza autentica per scoprire i sapori tradizionali della regione.',
        duration: '2-3 ore',
        difficulty: 'Principiante',
        season: 'Tutto l\'anno',
        price: '€25-45',
        locations: [
            'Scanno',
            'Villetta Barrea'
        ],
        requirements: [
            'Età minima: 18 anni per degustazione vini',
            'Prenotazione obbligatoria',
            'Abiti casual'
        ],
        included: [
            'Degustazione vini',
            'Prodotti tipici locali',
            'Visita guidata alla cantina',
            'Assicurazione'
        ],
        highlights: [
            'Vini locali di qualità',
            'Prodotti tipici abruzzesi',
            'Visita alla cantina storica',
            'Esperienza autentica',
            'Possibilità di acquisto'
        ]
    },
    arrosticini_mucciante: {
        name: 'Arrosticini al Mucciante',
        subtitle: 'Tradizione Culinaria Abruzzese Autentica',
        description: 'Vivi il sapore autentico degli arrosticini abruzzesi al ristorante storico Mucciante. Un\'esperienza culinaria tradizionale che ti farà conoscere i sapori più autentici della regione.',
        duration: '1-2 ore',
        difficulty: 'Principiante',
        season: 'Tutto l\'anno',
        price: '€15-25',
        locations: [
            'Mucciante',
            'Zona Rocca Calascio'
        ],
        requirements: [
            'Prenotazione consigliata',
            'Abiti casual'
        ],
        included: [
            'Arrosticini tradizionali',
            'Vino locale',
            'Contorni tradizionali',
            'Atmosfera autentica'
        ],
        highlights: [
            'Ristorante storico',
            'Preparazione tradizionale',
            'Sapori abruzzesi autentici',
            'Abbinamento con vino locale',
            'Esperienza culturale'
        ]
    },
    sextantio: {
        name: 'Pernottamento all\'Albergo Sextantio',
        subtitle: 'L\'Albergo Diffuso del Borgo',
        description: 'Soggiorna nell\'unico Albergo Sextantio, un albergo diffuso che preserva l\'architettura autentica di Santo Stefano di Sessanio. Un\'esperienza indimenticabile immersa nella storia e nella tradizione.',
        duration: 'Pernottamento',
        difficulty: 'Principiante',
        season: 'Tutto l\'anno',
        price: '€150-300 per notte',
        locations: [
            'Santo Stefano di Sessanio'
        ],
        requirements: [
            'Prenotazione obbligatoria',
            'Documento valido'
        ],
        included: [
            'Pernottamento',
            'Colazione tradizionale',
            'Camera storica',
            'Servizi alberghieri'
        ],
        highlights: [
            'Architettura storica',
            'Atmosfera autentica',
            'Colazione tradizionale',
            'Esperienza unica',
            'Posizione nel borgo'
        ]
    },
    wild_life_spotting: {
        name: 'Fauna Selvatica',
        subtitle: 'Scopri la natura selvaggia dell Abruzzo',
        description: 'Alla scoperta dei daini e del lupo',
        duration: '2 ore',
        difficulty: 'Facile'
    }
};

export default activities;
